<template>
	<div class="manage">
		<div style="" class="top">
			<el-row>
				<el-col :span="12">
					<el-input v-model="input3" style="height: 30px;" placeholder="此为滞纳信息库：请输入产品名称/品牌/型号/订货号/替代型号">
						<template #append>
							<el-button type="primary" class="button" style="width:60px">
								<el-icon color="#fff" size="12px" class="no-inherit">
									<Search />
								</el-icon>
							</el-button>
						</template>
					</el-input>
				</el-col>
				<el-col :span="12" style="text-align:right">
					<el-button>删除</el-button>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="table">
					<el-table :data="tableData" :height="400" :header-cell-style="{'background-color': '#e5e5e5'}" size="small" style="width: 100%">
						<el-table-column type="selection" width="55" />
						<el-table-column prop="date" label="品牌" width="180" />
						<el-table-column prop="address" label="产品名称" />
						<el-table-column prop="name" label="型号" width="180" />
						<el-table-column prop="address" label="订货号" />
						<el-table-column prop="address" label="列表价" />
						<el-table-column prop="address" label="审核状态" />
					</el-table>
				</el-col>
				<el-col :span="24" class="page">
					<el-pagination :pager-count="5" background layout="prev, pager, next" :total="1000" />
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	data() {

		return {
			input3: '',
			tableData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {

	}
}
</script>
<style lang="less" scoped>
:deep(.el-input-group__append) {
	background: #ff8a5c;
}
</style>